<template>
  <div
    :class="{
    'header': true,
    'black': otherClass,
    'fix': isFixed,
    'fix_a': isFixed2,
    'index_fix': isIndexFixed,
    'index': isIndex,
      'active':navoOpened
  }"
  >
    <div class="container">
      <header class="nav-tab" @click="closeNav">
        <div class="logo fl">
          <router-link to="/">
            <img src="@/assets/images/logo.png" alt />
            <img src="@/assets/images/logo.svg" alt />
          </router-link>
        </div>
        <div v-show="$route.name !== 'login' && $route.name !== 'register'" class="tabs fl nav_pc">
          <div class="el-menu-e">
            <div class="tab-btn index_btn">
              <div class="tab-btn-i">
                <router-link to="/">首页</router-link>
              </div>
            </div>
            <div
              v-for="(item,index) in list"
              :key="index"
              :class="{
                        'active':showPro2 === index,
                        'hover':isHover === index
                        }"
              @mouseenter="isHover = index"
              @mouseleave="isHover = -1"
              class="tab-btn"
            >
              <div
                v-if="item.children.length > 0"
                :class="{
                'has-child':item.children.length > 0
              }"
                @click="mNav(index)"
                class="tab-btn-i"
              >{{ item.data.title }}</div>

              <div v-else class="tab-btn-i">
                <router-link
                  v-if="item.data.url.indexOf('http') == -1"
                  :to="item.data.url"
                >{{ item.data.title }}</router-link>
                <a v-else :href="item.data.url">{{ item.data.title }}</a>
              </div>
              <div class="tab-item" @click="isHover = -1" v-if="item.children.length > 0">
                <p v-for="(n,i) in item.children" :key="i">
                  <router-link
                    v-if="n[0].url.indexOf('http') == -1"
                    :to="`${n[0].url}?cate=${n[0].id}`"
                  >
                    {{ n[0].title }}
                    <span v-if="n[0].isNew">{{ n[0].isNew }}</span>
                  </router-link>
                  <a v-else :href="n[0].url">{{ n[0].title }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="tabs fl nav_m" :class="{
                'active':navoOpened
              }">
          <el-menu class="el-menu-vertical-demo" unique-opened>
            <div>
              <el-menu-item index="0">
                <span slot="title">
                  <router-link to="/">首页</router-link>
                </span>
              </el-menu-item>
            </div>
            <div v-for="(item, index) in list" :key="index">
              <el-submenu v-if="item.children.length > 0" :index="(index + 1) + ''">
                <template slot="title">
                  <span>{{ item.data.title }}</span>
                </template>
                <el-menu-item
                  :index="(index + 1) + '-' + (i + 1)"
                  v-for="(n,i) in item.children"
                  :key="i"
                  v-if="item.children.length > 0 && n[0].title !== '查询存证'"
                >
                  <router-link v-if="n[0].url.indexOf('http') == -1" :to="n[0].url">
                    {{ n[0].title }}
                    <span v-if="n[0].isNew">{{ n[0].isNew }}</span>
                  </router-link>
                  <a v-else :href="n[0].url">{{ n[0].title }}</a>
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="(index + 1) + ''">
                <span slot="title">
                  <router-link
                    v-if="item.data.url.indexOf('http') == -1"
                    :to="item.data.url"
                  >{{ item.data.title }}</router-link>
                  <a v-else :href="item.data.url">{{ item.data.title }}</a>
                </span>
              </el-menu-item>
            </div>
          </el-menu>
        </div>
        <div v-if="!logined" :class="navoOpened ? 'login-wrap fr active' : 'login-wrap fr'">
          <a :href="loginUrl" v-show="loginUrl">登录</a>
          <a class="register" href="https://user.esign.cn/regist?account=">注册有礼</a>
        </div>

        <div
          v-if="logined"
          class="logined fr"
          :class="navoOpened ? 'logined fr active' : 'logined fr'"
        >
          <div class="self">
            <a v-if="!isM" class="to-check" href="https://web.esign.cn/home" target="_blank">进入签约平台</a>
            <a v-else class="to-check" href="https://h5.esign.cn/" target="_blank">进入签约平台</a>
            <div class="user-name">
              <!-- <img class="head-url" :src="userInfo.head || headerUrl" alt=""> -->
              <p>
                <a href="https://web.esign.cn/home">{{ userInfo.prop.properties.name || 'ei' }}</a>
              </p>
              <span class="realname-status" v-if="!userInfo.realnameStatus">未实名</span>
              <div class="handler">
                <div class="login-handler">
                  <div class="read-box">
                    <div class="i" v-show="!userInfo.realnameStatus">
                      <a class="real-name" @click="readname" href="javascript:;">
                        <img src="@/assets/images/weirenzheng@2x.png" alt />未实名认证
                      </a>
                      <a class="real-now" href="javascript:;" @click="readname">立即认证</a>
                    </div>
                    <div class="i" v-show="!userInfo.realnameStatus">
                      <a class="tip" href="javascript:;" @click="readname">此时签署文件不具有法律效力</a>
                    </div>
                    <div class="realed" v-show="userInfo.realnameStatus">
                      <img src="@/assets/images/renzheng@2x.png" alt />已实名认证
                    </div>
                  </div>
                  <div class="btn-box">
                    <div class="pay-box">
                      <a class="cz-btn fr" href="https://order.esign.cn/MyWallet" target="_blank">充值</a>
                      <p class="pay-again fl">
                        <i class="el-icon-goods"></i> 套餐续费
                      </p>
                    </div>
                    <div class="exit">
                      <a @click="exit" href="javascript:;">
                        <i class="el-icon-switch-button"></i> 退出登录
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="login-wrap-sm" @click="navoOpened = !navoOpened">
          <div :class="{
                'active':navoOpened
            }" class="icon">
            <span></span>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
import globalConfig from '@/lib/http/global-config'
export default {
  name: 'Header',
  mounted() {
    this.getList()
    this.getUserInfo()
    this.setClass()

    if (window.innerWidth > 768) {
      this.isM = false
    } else {
      this.isM = true
    }

    window.addEventListener('scroll', this.scroll)
  },
  watch: {
    $route() {
      this.setClass()
    }
  },
  data() {
    return {
      headerUrl: require('@/assets/images/head-img.png'),
      userInfo: {},
      loginUrl: '',
      logined: false,
      navoOpened: false,
      showPro: false,
      showPro2: null,
      tab: [],
      list: [],
      otherClass: false,
      isFixed: false,
      isFixed2: false,
      isIndex: false,
      isIndexFixed: false,
      isHover: -1,
      isM: false
    }
  },
  methods: {
    // 立即认证
    async readname() {
      this.$axios.defaults.withCredentials = true
      var data = {
        redirectUrl: location.href
      }
      const res = await this.$axios.$post(`${globalConfig.eBaseUrl}/webserver/user/accounts/realname`, data)
      if (res.code === 0) {
        location.href = res.data.url
      }
    },
    setClass() {
      let fp = this.$route.path

      if (fp == '/' || fp == '/contact' || fp == '/introdution' || fp == '/join' || fp == '/qualification') {
        this.otherClass = false
      } else {
        this.otherClass = true
      }
      if (fp == '/') {
        this.isIndex = true
      } else {
        this.isIndex = false
      }
      this.scroll()
    },
    scroll() {
      let fp = this.$route.path
      this.globalSt = document.documentElement.scrollTop || document.body.scrollTop
      if (fp == '/') {
        if (this.globalSt > 60) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
        if (this.globalSt > 120) {
          this.isFixed2 = true
        } else {
          this.isFixed2 = false
        }
        if (this.globalSt > window.innerHeight - 60) {
          this.isIndexFixed = true
        } else {
          this.isIndexFixed = false
        }
      } else {
        this.isIndexFixed = false
        this.isFixed2 = false
        if (this.globalSt > 0) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
      }
    },
    async getUserInfo() {
      this.$axios.defaults.withCredentials = true
      var data = {
        apiCode: 'GET_USER_INFO',
        param: ''
      }
      const sumData = await this.$axios.get(`${globalConfig.eBaseUrl}/webserver/v1/accounts/sys_accountId/getAllInfo`, {
        params: {
          to: new Date().getTime()
        },
        headers: {
          'X-Tsign-Open-Tenant-Id': '',
          'X-Tsign-Open-App-Id': '1111564250',
          'X-Tsign-Client-Id': 'WEB'
        }
      })

      if (sumData.message === '成功') {
        this.logined = true
        this.userInfo = sumData.data
        this.userInfo.head = sumData.data.prop.properties.head
        this.userInfo.realnameStatus = sumData.data.baseRealname.status
      } else {
        // this.loginUrl = sumData.data.loginUrl
        this.loginUrl = 'https://user.esign.cn/login'
        this.logined = false
      }
    },
    // 获取tab列表
    async getList() {
      try {
        // 不存在缓存，请求数据
        var res = await this.$axios.get('/api/cate/list/1')
        this.list = res.data
      } catch (error) {
        console.log(error)
      }
    },
    // 退出登陆
    async exit() {
      try {
        this.$axios.defaults.withCredentials = true
        let sumData = await this.$axios.$post(globalConfig.eBaseUrl + '/account-webserver/user/accounts/logout', {
          data: {
            to: new Date().getTime()
          }
        })
        this.getUserInfo()
      } catch (error) {
        console.log(error)
      }
    },
    mNav(i) {
      if (this.showPro === i) {
        this.showPro = false
      } else {
        this.showPro = i
      }
    },
    closeNav(e) {
      if (e.target.nodeName == 'A') {
        this.navoOpened = false
      } else if (e.target.nodeName == 'IMG') {
        if (e.target.parentNode.nodeName) {
          this.navoOpened = false
        }
      }
    }
  }
}
</script>

<style lang='less' scoped>
.banxin,
.container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
}
.index_btn {
  display: none !important;
}
.header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000;
  width: 100%;

  &:not(.index) {
    transition: all 0.4s ease-in-out;
  }

  .logined {
    font-size: 16px;
    font-weight: 400;
    color: rgba(32, 38, 64, 1);
    line-height: 26px;
    color: #fff;

    a {
      color: #fff;
      transition: all 0.4s ease-in-out;
      &:hover {
        color: #e61717;
      }
    }

    .self {
      padding-top: 16px;
    }

    .to-check {
      float: left;
      margin-right: 50px;
    }

    .user-name {
      position: relative;
      // overflow: hidden;
      float: left;
      cursor: pointer;

      &:hover .login-handler {
        animation-name: fade-up-header;
        animation-duration: 0.3s;
        animation-timing-function: ease;
        animation-fill-mode: forwards;
        display: block;
      }

      .head-url {
        width: 29px;
        height: 29px;
        float: left;
      }

      p {
        float: left;
      }

      .realname-status {
        float: left;
        line-height: 13px;
        background: rgba(230, 23, 23, 1);
        font-size: 12px;
        color: #fff;
        padding: 2px 3px;
        margin-top: 5px;
        margin-left: 9px;
      }
    }
    .handler {
      padding-top: 20px;
      position: absolute;
      right: 0px;
      top: 23px;
      z-index: 100;
    }
    .login-handler {
      display: none;
      width: 240px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      color: #000;
      border-radius: 5px;
      overflow: hidden;

      a {
        color: #000;
      }

      .read-box {
        padding: 20px 16px 18px 20px;
        background: rgba(245, 247, 250, 1);
        .realed {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
            vertical-align: middle;
          }
        }
        .i {
          position: relative;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
        }

        a {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          cursor: pointer;
        }

        .real-name {
          color: rgba(230, 23, 23, 1);
          display: flex;
          align-items: center;
          justify-content: flex-start;
          img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
            vertical-align: middle;
          }
        }

        .real-now {
          color: rgba(24, 144, 255, 1);

          &:hover {
            text-decoration: underline;
          }
        }

        .tip {
          font-size: 12px;
          font-weight: 400;
          color: rgba(102, 107, 128, 1);
          line-height: 17px;
          margin-top: 5px;
        }
      }

      .btn-box {
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        padding: 20px 20px 18px;

        .pay-box {
          // display: flex;
          // justify-content: space-between;
          margin-bottom: 10px;
          overflow: hidden;

          .cz-btn {
            width: 60px;
            height: 24px;
            line-height: 24px;
            color: #e61717;
            border: 1px solid rgba(230, 23, 23, 1);
            text-align: center;
            transition: all 0.4s ease-in-out;

            &:hover {
              color: #fff;
              background-color: #e61717;

              & + p {
                color: #e61717;
              }
            }
          }
        }

        .pay-again {
          font-size: 14px;
          font-weight: 400;
          color: rgba(32, 45, 64, 1);
          line-height: 20px;
        }

        .exit a:hover {
          color: #e61717;
        }
      }
    }
  }

  &.index {
    position: absolute;

    &.fix {
      position: fixed;
      transform: translateY(-100%);
      background: transparent;

      .nav-tab {
        .tabs {
          .tab-btn-i {
            color: #fff;
          }
        }

        .logo {
          img {
            visibility: hidden;
            opacity: 0;

            &:nth-child(2) {
              visibility: visible;
              opacity: 1;
            }
          }
        }
      }

      .login-wrap-sm .icon {
        span::before,
        span::after,
        span {
          background: #fff;
        }

        &.active {
          span {
            background-color: transparent;
          }
        }
      }

      .login-wrap {
        a {
          color: #fff;

          &.register {
            border: 1px solid #fff;
            color: #fff;
          }
        }
      }

      &.fix_a {
        transition: transform 0.4s ease-in-out;
        background: #fff;

        &.index_fix {
          transform: translateY(0%);

          .nav-tab {
            .tabs {
              .tab-btn-i {
                color: #202640;
                &:hover {
                  color: #e61717;
                }
              }
            }

            .logo {
              img {
                visibility: visible;
                opacity: 1;

                &:nth-child(2) {
                  visibility: hidden;
                  opacity: 0;
                }
              }
            }
          }

          .login-wrap-sm .icon {
            span::before,
            span::after,
            span {
              background: #000;
            }

            &.active {
              span {
                background-color: transparent;
              }
            }
          }

          .login-wrap {
            a {
              color: #202640;
              &:hover {
                color: #e61717;
              }

              &.register {
                border: 1px solid #e61717;
                color: #e61717;
              }
            }
          }
        }
      }
    }
  }

  &.fix2 {
    top: -60px;
  }

  .nav-tab {
    height: 60px;
    color: #202640;
    position: relative;

    .logo {
      width: 110px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;

      img {
        visibility: hidden;
        opacity: 0;
        transition: all 0.4s ease-in-out;

        &:nth-child(2) {
          position: absolute;
          top: 0;
          left: 0;
          visibility: visible;
          opacity: 1;
        }
      }
    }

    .tabs {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 999;

      &.nav_pc {
        display: block;
      }

      &.nav_m {
        display: none;
        padding-bottom: 100px;
        .el-menu-item a {
          display: block;
          span {
            display: inline-block;
            background: #e61717;
            color: #fff;
            border-radius: 8px 8px 8px 0;
            line-height: 16px;
            padding: 0 6px;
            text-transform: uppercase;
            font-size: 12px;
            margin-left: 10px;
          }
        }
      }

      .tab-btn {
        display: inline-block;
        position: relative;

        .tab-btn-i {
          cursor: pointer;
          transition: all 0.4s ease-in-out;
        }

        &:hover .tab-btn-i {
          color: #e61717;
        }

        .tab-item {
          position: absolute;
          width: 200px;
          top: 60px;
          left: 8px;
          background-color: #fff;
          color: #202d40;
          display: none;
          box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
          border-radius: 2px;
          padding-top: 10px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(32, 45, 64, 1);
          line-height: 36px;
          padding-top: 5px;
          padding-bottom: 5px;
          border-radius: 5px;
          z-index: 999;

          a {
            display: block;
            width: 100%;
            padding-left: 20px;
            text-align: left;

            &.router-link-active {
              color: #e61717;
            }

            span {
              display: inline-block;
              background: #e61717;
              color: #fff;
              border-radius: 8px 8px 8px 0;
              line-height: 16px;
              padding: 0 6px;
              text-transform: uppercase;
              font-size: 12px;
              margin-left: 10px;
            }
          }

          a:hover {
            background: #f5f7fa;
          }
        }

        &.hover .tab-item {
          animation-name: fade-up-header;
          animation-duration: 0.3s;
          animation-timing-function: ease;
          animation-fill-mode: forwards;
          display: block;

          &::after {
            content: ' ';
            position: absolute;
            top: -10px;
            left: 20px;
            margin: auto;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 10px 10px 10px;
            border-color: transparent transparent #fff transparent;
          }
        }
      }

      .tab-btn-i {
        color: #fff;
        line-height: 60px;
        font-size: 16px;
        padding: 0 25px;
        transition: all 0.4s ease-in-out;
        position: relative;

        &:after {
          content: '';
          display: block;
          position: absolute;
          width: 100%;
          height: 3px;
          left: 0;
          bottom: 10px;
          background: rgba(255, 255, 255, 0);
        }

        a {
          color: inherit;
          display: block;
        }
      }

      .tab-btn-i.act:after {
        background: #e61717;
      }
    }

    .login-wrap {
      // position: absolute;
      // right: 0;
      // top: 50%;
      // transform: translateY(-50%);
      margin-top: 12px;

      a {
        display: inline-block;
        width: 120px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        font-size: 16px;
        background-color: transparent;
        transition: all 0.4s ease-in-out;

        &:hover {
          color: #e61717;
        }
      }

      .register {
        border: 1px solid #fff;
        line-height: 34px;

        &:hover {
          background: #e61717;
          border-color: #e61717;
          color: #fff !important;
        }
      }
    }
  }

  .login-wrap-sm {
    display: none;

    .icon {
      position: absolute;
      top: 1px;
      right: 0;
      height: 48px;
      width: 48px;
      overflow: hidden;
      text-indent: 100%;
      white-space: nowrap;
      color: transparent;
      z-index: 1100;

      &.active {
        span {
          background-color: transparent;
        }

        span::after {
          transform: rotate(-45deg);
        }

        span::before {
          transform: rotate(45deg);
        }
      }

      span {
        position: absolute;
        left: 50%;
        top: 50%;
        bottom: auto;
        right: auto;
        background-color: #fff;
        height: 3px;
        width: 24px;
        -webkit-transform: translateX(-50%) translateY(-50%);
        -ms-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        -webkit-transition: background-color 0.2s;
        -o-transition: background-color 0.2s;
        transition: background-color 0.2s;

        &::after {
          position: absolute;
          background-color: #fff;
          height: 3px;
          width: 24px;
          content: '';
          left: 0;
          transition: -webkit-transform 0.2s;
          -webkit-transition: -webkit-transform 0.2s;
          -o-transition: transform 0.2s;
          transition: transform 0.2s;
          transition: transform 0.2s, -webkit-transform 0.2s;
          transform: translateY(8px);
        }

        &::before {
          position: absolute;
          background-color: #fff;
          height: 3px;
          width: 24px;
          content: '';
          left: 0;
          transition: -webkit-transform 0.2s;
          -webkit-transition: -webkit-transform 0.2s;
          -o-transition: transform 0.2s;
          transition: transform 0.2s;
          transition: transform 0.2s, -webkit-transform 0.2s;
          transform: translateY(-8px);
        }
      }
    }
  }

  &.black {
    .logined {
      color: #202640;
      a {
        color: #202640;
        &:hover {
          color: #e61717;
        }
      }
    }
    .nav-tab {
      .tabs {
        .tab-btn-i {
          color: #202640;
        }
      }

      .logo {
        img {
          visibility: visible;
          opacity: 1;

          &:nth-child(2) {
            visibility: hidden;
            opacity: 0;
          }
        }
      }

      .login-wrap-sm .icon {
        span::before,
        span::after,
        span {
          background: #000;
        }

        &.active {
          span {
            background-color: transparent;
          }
        }
      }
    }

    .login-wrap {
      a {
        color: #202640;

        &.register {
          border: 1px solid #e61717;
          color: #e61717;
        }
      }
    }
  }

  &.fix {
    background: #fff;

    .login-wrap {
      a {
        color: #202640;

        &.register {
          border: 1px solid #e61717;
          color: #e61717;
        }
      }
    }

    .nav-tab {
      .tabs {
        .tab-btn-i {
          color: #202640;
        }
      }

      .logo {
        img {
          visibility: visible;
          opacity: 1;

          &:nth-child(2) {
            visibility: hidden;
            opacity: 0;
          }
        }
      }
    }
    .logined {
      color: #202640;
      a {
        color: #202640;
        &:hover {
          color: #e61717;
        }
      }
    }
    .login-wrap-sm .icon {
      span::before,
      span::after,
      span {
        background: #000;
      }

      &.active {
        span {
          background-color: transparent;
        }
      }
    }
  }
}

@keyframes fade-up-header {
  0% {
    transform: translate(0%, 20px);
  }
  100% {
    transform: translate(0%, 0px);
  }
}

.tabs-sm {
  display: none;
}

@media only screen and (max-width: 768px) {
  .user-name {
    display: none;
  }
  .index_btn {
    display: block !important;

    .tab-btn-i {
      color: #202640 !important;
    }
  }

  .header {
    &.active {
      position: fixed !important;
      transform: none !important;
      .container {
        background-color: #fff;
      }
    }
  }

  .logined {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 999;
    height: 100px;
    display: none;
    justify-content: center;
    align-items: flex-start;
    margin-right: 0;
    padding: 20px 5% 0;
    &.active {
      display: flex;
    }
    .self {
      padding: 0;
      width: 100%;
      text-align: center;
    }
    .to-check {
      margin-right: 0;
      width: 100%;
      height: 36px;
      line-height: 36px;
      background: #e61717;
      color: #fff !important;
    }
  }

  .header .nav-tab {
    width: 100%;
    height: 50px;

    .tabs {
      display: none;
      width: 100%;
      height: calc(100vh - 50px);
      overflow: auto;
      line-height: 50px;
      position: fixed;
      left: 0;
      top: 50px;
      z-index: 999;
      background: #fff;
      transform: translateX(0);
      transition: all 0.2s linear;

      &.nav_pc {
        display: none;
      }

      &.active {
        &.nav_m {
          display: block;
        }
      }
    }

    .login-wrap {
      display: none;
      &.active {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        z-index: 999;
        height: 100px;

        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin: 0;
        padding: 20px 5% 0;
        a {
          width: 49%;
          height: 36px;
          line-height: 36px;
          border: 1px solid #e61717;
          color: #e61717 !important;
          &:first-child {
            margin-right: 2%;
            background: #e61717;
            color: #fff !important;
          }
        }
      }
    }

    .login-wrap-sm {
      display: block;
    }

    .tabs-sm {
      display: block;
    }
  }
}

.header.active .nav-tab .logo img {
  opacity: 1;
  visibility: visible;
}

.header.active .nav-tab .logo img:nth-child(2) {
  opacity: 0;
  visibility: hidden;
}

.header .icon.active span::before,
.header .icon.active span::after {
  background: #000;
}
</style>
<style>
.el-menu {
  border-right: 0;
}
.el-menu > div {
  border-bottom: 1px solid #eee;
}
.el-submenu__title:hover {
  background: #fff;
}
</style>
